import React from "react";

import LinearGauge from "./LinearGaugeComponent"; 

function PISCCGraphicsComponent({ state }) {
  return (
    <>
      <div className="sparkboxes">
        <div style={{ display: "flex", justifyContent: 'center' }}>
          <div>
            <h2 className='piscc-graphic-title'>Año</h2>
            <div style={{ display: "flex", justifyContent: 'center' }}>
              <div style={{ alignSelf: "center", maxWidth: '175px' }}>
                <div className="line line-100 text-center box box2">
                  <div className="text-box">Meta</div>
                  <div>{Math.round(100 * state.nivel) / 100}</div>
                </div>
                <div className="line line-100 text-center box box1">
                  <div className="text-box">Realizado</div>
                  <div>{Math.round(100 * state.indYear) / 100}</div>
                </div>
                <div className="line line-100 text-center box box3">
                  <div className="text-box">Pendiente</div>
                  <div>{Math.round(100 * (state.nivel - state.indYear)) / 100}</div>
                </div>
              </div>
              <div >
                <div className="line line-100 text-center">
                  <LinearGauge
                    nivel={Math.round(10 * state.nivel) / 10}
                    ind={Math.round(10 * state.indYear) / 10}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2 className='piscc-graphic-title'>Cuatrenio</h2>
            <div style={{ display: "flex", justifyContent: 'center' }}>
              <div style={{ alignSelf: "center", maxWidth: '175px' }}>
                <div className="line line-100 text-center box box2">
                  <div className="text-box">Meta</div>
                  <div>{Math.round(100 * state.nivel) / 100}</div>
                </div>
                <div className="line line-100 text-center box box1">
                  <div className="text-box">Realizado</div>
                  <div>{Math.round(100 * state.indTot) / 100}</div>
                </div>
                <div className="line line-100 text-center box box3">
                  <div className="text-box">Pendiente</div>
                  <div>{Math.round(100 * (state.nivel - state.indTot)) / 100}</div>
                </div>
              </div>
              <div>
                <div className="line line-100 text-center">
                  <LinearGauge
                    nivel={Math.round(10 * state.nivel) / 10}
                    ind={Math.round(10 * state.indTot) / 10}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default PISCCGraphicsComponent;
